"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseColumn = require("./support/BaseColumn");
var _ColoredIdIcon = _interopRequireDefault(require("../../../../components/navigation/breadcrumbs/ColoredIdIcon"));
var _Cell = require("../cell/Cell.styled");
var _jsxRuntime = require("react/jsx-runtime");
var ColoredIdIconColumn = function ColoredIdIconColumn(_) {
  return null;
};
ColoredIdIconColumn.toColumnDef = function (child) {
  var _child$props = child.props,
    accessorKey = _child$props.accessorKey,
    renderProps = _child$props.renderProps;
  return _objectSpread({}, (0, _BaseColumn.defaultColumnDef)(child.props), {
    accessorKey: accessorKey,
    aggregationFn: undefined,
    cell: function cell(_ref) {
      var row = _ref.row,
        getValue = _ref.getValue;
      var value = getValue();
      if (value) {
        var props = renderProps(row.original);
        if (props) {
          var color = props.color,
            text = props.text;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell.StyledCell, {
            align: child.props.align,
            narrow: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ColoredIdIcon.default, {
              color: color,
              children: text
            })
          });
        }
      }
      return null;
    }
  });
};
var _default = exports.default = ColoredIdIconColumn;